<template>
  <div class="view-picker d-flex align-items-center">
    <span>View:</span>
    <div class="d-flex flex-wrap">
      <b-btn
        v-for="(view, i) of applyToLayers.concat(null)"
        :key="i"
        @click.prevent="handleViewPicked(view)"
        variant="outline-secondary"
        class="ml-2"
        :class="{ active: currentView === view }"
      >
        {{ view ? view.name : 'Home' }}
      </b-btn>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'view-picker',
  computed: {
    ...mapState([
      'shellProject',
      'currentView',
    ]),
    ...mapGetters([
      'applyToLayers',
    ]),
  },
  methods: {
    ...mapMutations([
      'setCurrentView',
    ]),

    handleViewPicked(view) {
      this.setCurrentView(view);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ViewPicker.vue